import { render, staticRenderFns } from "./customEvents.vue?vue&type=template&id=3c6eb5b2&"
import script from "./customEvents.vue?vue&type=script&lang=js&"
export * from "./customEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6eb5b2')) {
      api.createRecord('3c6eb5b2', component.options)
    } else {
      api.reload('3c6eb5b2', component.options)
    }
    module.hot.accept("./customEvents.vue?vue&type=template&id=3c6eb5b2&", function () {
      api.rerender('3c6eb5b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/customEvents.vue"
export default component.exports